module.exports = __webpack_public_path__ + "static/media/upcoming.281056cd.svg";